import React, { Fragment } from 'react';

import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState, } from 'appredux';



import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import theme from 'themes';

import Typography from '@material-ui/core/Typography';



import { Tooltip, Icon, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { Trans } from 'react-i18next';

//PM 2021-10-21
//wstrzykniecie tylko uzywanych pol z magazynu danych
//wyrzucenie ladowanie
interface DialogProps extends WithStyles<typeof styles> {
    page: IPageState,
  
    randomNum: number,
    submit: () => Promise<void>
}

interface DialogState {
    open: boolean
}

class DialogUkryjPracownika extends React.Component<DialogProps, DialogState>  {

    //PM 2021-09-17
    constructor(props: DialogProps) {
        super(props, {});
        this.state = {
            open: true
        }
    }

    componentDidUpdate(prevProps: DialogProps) {
        if(this.props.randomNum !== prevProps.randomNum){
            this.setState({open: true})
        }
    }

    closeConfirm = () => {
        this.setState({ open: false });
    };

    submit = () => {
        this.closeConfirm()
        this.props.submit()


    }

    // ukryjPracownika = async () => {
    //     this.closeConfirm()
    //     this.props.ukryjPracownika(this.props.pracownik)
    // };

    render() {
        const classes = this.props.classes;
       
        return (
            <>
                <Dialog
                    //disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.state.open}
                    //onEscapeKeyDown={this.closeConfirm}
                    //onBackdropClick={this.closeConfirm}
                    fullWidth
                >
                    <DialogTitle disableTypography className={classes.paddingBottom0}>
                        <Typography gutterBottom variant="h6" component="h2" color="primary"
                            className={`${classes.primary} ${classes.headline}`}>
                            <b style={{ textTransform: "lowercase" }}><Trans>Information</Trans></b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText className={classes.dialogContentText} >
                            {""}
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                        <Trans>{"trwają prace techniczne"}</Trans>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                        <Trans>{"płatność chwilowo wyłączona"}</Trans> <b className={`${classes.primary} ${classes.right} ${classes.rightText}`}></b>
                        </DialogContentText>
                       
                    </DialogContent>

                    <DialogActions>
                        <Button variant={"outlined"} color="primary" size="small" className={classes.button}
                            onClick={this.closeConfirm}>
                            <b><Trans>Back</Trans></b>
                        </Button>
                        <Button variant="contained" color="primary" size="small" className={classes.button}
                            onClick={this.submit}>
                            <b>OK</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </>

        );
    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      secondary: {
        color: theme.palette.secondary.main
      },
      paddingBottom0: {
        paddingBottom: 0
      },
      headline: {
        //fontFamily: "\"'Open Sans'\", sans-serif",
        lineHeight: "20px",
        //fontSize: "16px",
        //fontWeight: 600
      },
      dialogContentText: {
        display: "flex" as "flex",
        color: theme.palette.text.secondary,
        whiteSpace: "pre" as "pre",
        fontSize: theme.typography.body1.fontSize,
        fontFamily: theme.typography.body1.fontFamily,
        fontWeight: theme.typography.body1.fontWeight,
        lineHeight: theme.typography.body1.lineHeight,
        letterSpacing: theme.typography.body1.letterSpacing,
        marginBottom: '12px'
        //fontSize: "14px"
      },
      button: {
        textTransform: "none" as "none"
    },
    right: {
        float: "right" as "right"
    },
    rightText: {
        width: "100%",
        //maxWidth: "70%",
        whiteSpace: "break-spaces" as "break-spaces",
        textAlign: "end" as "end"


    }
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogUkryjPracownika));

